/* New Comfort · productpagina 2026 — iRest Dual Core V8 (FC Bayern): galerij, kleurkeuze, subnav, maten, specs */
(function(){
  'use strict';
  var $=function(s,r){return (r||document).querySelector(s);},
      $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  function stickOff(){ var h=$('sticky-header')||$('.section-header'); var b=h?h.getBoundingClientRect():null; var sub=$('.ncp-sub');
    return (b&&b.bottom>0?b.bottom:0)+(sub?sub.offsetHeight:0)+8; }
  function go(id){ var t=document.getElementById(id); if(!t) return;
    window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-stickOff(),behavior:'smooth'}); }

  /* ---- 1 · galerij naar de mediakolom van main-product ---- */
  var gal=$('#ncpGal'), media=$('.product__media-wrapper');
  if(gal&&media){ media.classList.add('ncp-media'); $$(':scope > *',media).forEach(function(c){ c.style.display='none'; });
    media.insertBefore(gal,media.firstChild); gal.hidden=false; }

  /* ---- 2 · galerij: vaste foto's, klik op een miniatuur ---- */
  var img=gal?$('#stageImg',gal):null, bg=gal?$('.gal__bg',gal):null;
  var show=function(src){ if(!img) return; img.src=src; if(bg) bg.style.backgroundImage='url("'+src+'")'; };
  if(gal){
    $$('.thumb',gal).forEach(function(t){
      t.addEventListener('click',function(){
        $$('.thumb',gal).forEach(function(x){ x.setAttribute('aria-pressed', x===t?'true':'false'); });
        show(t.getAttribute('data-full'));
      });
    });
  }

  /* ---- 2b · kleurkeuze: de galerij volgt de gekozen kleur (zwart-rood of beige) ---- */
  var CDN='https://cdn.shopify.com/s/files/1/0807/7629/8821/files/';
  var KLEUR={
    'zwart-rood':{src:CDN+'dual-core-v8-360-315.jpg?width=1400'},
    'beige':{src:CDN+'massagestoel-irest-dual-core-V8-315-beige.jpg?width=1400'}
  };
  var kleurKies=function(naam){
    var k=KLEUR[naam];
    if(!k||!img) return;
    show(k.src);
    if(gal) $$('.thumb',gal).forEach(function(x){ x.setAttribute('aria-pressed','false'); });
    var eerste=gal?$('.thumb',gal):null;
    if(eerste && naam==='zwart-rood') eerste.setAttribute('aria-pressed','true');
  };
  document.addEventListener('change',function(e){
    var t=e.target;
    if(!t) return;
    if(t.tagName==='INPUT' && t.type==='radio' && KLEUR[t.value] && t.checked) kleurKies(t.value);
    if(t.tagName==='SELECT' && KLEUR[t.value]) kleurKies(t.value);
  });
  /* de swatch-labels kunnen ook zonder change-event vallen: luister op de klik */
  document.addEventListener('click',function(e){
    var l=e.target.closest && e.target.closest('label');
    if(!l) return;
    var inp=l.control || (l.htmlFor && document.getElementById(l.htmlFor));
    if(inp && inp.type==='radio' && KLEUR[inp.value]) setTimeout(function(){ kleurKies(inp.value); },0);
  });
  /* startkleur: als de geselecteerde optie al een kleur is */
  var checked=$$('input[type=radio]').filter(function(r){ return r.checked && KLEUR[r.value]; })[0];
  if(checked) kleurKies(checked.value);

  /* ---- 3 · kleurschuif: de zwart-rode foto over de beige, met een lijn om te schuiven ---- */
  var kl=$('#kleurKl'), klRange=$('#kleurRange');
  if(kl&&klRange){
    var top=$('.kl__top',kl), handle=$('.kl__h',kl);
    var zet=function(v){
      top.style.clipPath='inset(0 '+(100-v)+'% 0 0)';
      if(handle) handle.style.left=v+'%';
    };
    klRange.addEventListener('input',function(){ zet(+klRange.value); });
    zet(+klRange.value||50);
  }

  /* ---- 4 · subnav ---- */
  $$('[data-jump]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); go(a.getAttribute('data-jump'));
    if(a.closest('.sub__links')) $$('.sub__links a').forEach(function(x){ x.classList.toggle('on',x===a); }); }); });
  var subBuy=$('.ncp-sub .sub__buy a');
  if(subBuy) subBuy.addEventListener('click',function(e){ e.preventDefault(); go('showroom'); });

  /* ---- 5 · past hij? ---- */
  var room=$('#room'), wide=$('#wide'), door=$('#door');
  if(room&&wide&&door){
    /* maten uit de productbeschrijving: 177 cm rechtop, 190 cm languit, 86 cm breed */
    var LEN_UP=177, LEN_FLAT=190, W=86, DOOR=80;
    var plek=function(){
      var r=+room.value||0, w=+wide.value||0, out=[];
      if(r>=LEN_FLAT) out.push(['','Ook languit met de voetsteun uit past hij: dan is hij '+LEN_FLAT+' cm.']);
      else if(r>=LEN_UP) out.push(['no','Rechtop past hij ('+LEN_UP+' cm); languit met de voetsteun uit vraagt '+LEN_FLAT+' cm.']);
      else out.push(['no','Te krap: rechtop '+LEN_UP+' cm, languit met de voetsteun uit '+LEN_FLAT+' cm.']);
      out.push(w>=W?['','Breedte past: de stoel is '+W+' cm breed.']:['no','De stoel is '+W+' cm breed — '+w+' cm is te smal.']);
      $('#verdPlek').innerHTML=out.map(function(o){ return '<li class="'+o[0]+'">'+o[1]+'</li>'; }).join('');
    };
    var deur=function(){ var d=+door.value||0;
      $('#verdDoor').innerHTML = d>=DOOR
        ? '<li>Door een deur van '+d+' cm komt hij in één stuk naar binnen.</li>'
        : '<li class="no">'+d+' cm is smaller dan de '+DOOR+' cm die de stoel breed is. Bel ons — vaak halen we hem ter plekke uit elkaar.</li>'; };
    room.addEventListener('input',plek); wide.addEventListener('input',plek); door.addEventListener('input',deur);
    plek(); deur();
  }

  /* ---- 6 · specs ---- */
  var sb=$('#specBtn');
  if(sb) sb.addEventListener('click',function(){
    var g=$('#specgrid'), on=g.classList.toggle('all');
    sb.setAttribute('aria-expanded',on); sb.textContent=on?'Toon minder':'Toon alle kenmerken';
  });

  /* ---- 7 · rustige scroll-animatie (stijl vanuit JS, zodat niets onzichtbaar blijft) ---- */
  var zacht = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if(zacht && 'IntersectionObserver' in window){
    var st=document.createElement('style');
    st.textContent='.ncp .nc-rise{opacity:0;transform:translateY(18px);transition:opacity .62s cubic-bezier(.22,.61,.36,1),transform .62s cubic-bezier(.22,.61,.36,1)}.ncp .nc-rise.is-in{opacity:1;transform:none}';
    document.head.appendChild(st);
    var rise=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(!e.isIntersecting) return;
        e.target.classList.add('is-in'); rise.unobserve(e.target); });
    },{threshold:.12, rootMargin:'0px 0px -6% 0px'});
    [
      {els:$$('#massage .fgg'), kolommen:2, stap:120},
      {els:$$('#functies .fgg'), kolommen:2, stap:120},
      {els:$$('#bayern .bay__list li'), kolommen:2, stap:90},
      {els:$$('#past .nccard'), kolommen:2, stap:90}
    ].forEach(function(g){
      g.els.forEach(function(el,i){
        el.classList.add('nc-rise');
        el.style.transitionDelay=((i % g.kolommen)*g.stap)+'ms';
        rise.observe(el);
      });
    });
  }
})();
